import { Component, Input } from '@angular/core';
import { BaseComponent } from '@ids-components';
import { MODE_OPTIONS } from '@ids-constants';
import { FlAnalyzerProgressComponent } from './fl-analyzer-progress/fl-analyzer-progress.component';
import { CardComponent } from '@microsec/components';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { SelectModule } from 'primeng/select';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ConstantPipe, MomentPipe } from '@ids-pipes';

@Component({
  selector: 'app-fl-analyzer-overview',
  templateUrl: './fl-analyzer-overview.component.html',
  styleUrls: ['./fl-analyzer-overview.component.scss'],
  imports: [CommonModule, FormsModule, ToggleSwitchModule, SelectModule, CardComponent, MomentPipe, ConstantPipe, FlAnalyzerProgressComponent],
  providers: [ConstantPipe],
})
export class FlAnalyzerOverviewComponent extends BaseComponent {
  @Input() analyzer: any = {};

  MODE_OPTIONS = MODE_OPTIONS;
}
